import { render, staticRenderFns } from "./SegurArchives.vue?vue&type=template&id=a978f80a&scoped=true"
import script from "./SegurArchives.vue?vue&type=script&lang=js"
export * from "./SegurArchives.vue?vue&type=script&lang=js"
import style0 from "./SegurArchives.vue?vue&type=style&index=0&id=a978f80a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a978f80a",
  null
  
)

export default component.exports